import React, { useCallback } from 'react'

export default function TextBlock(props) {

    const updateValue = useCallback((e) => {
        props.updateParentValue(e.target.value)
    }, [props])

    return (
        <>
            <div>
                <div className="form-floating mb-3">
                    <input type={props.type} className="form-control" placeholder="demo" onChange={updateValue} value={props.value} disabled={props.disabled}/>
                    <label htmlFor="floatingInput">{props.label}</label>
                </div>
                <span style={{color:"red", position:"relative", top:"-15px"}}>{props.errorMessage}</span>
            </div>

        </>
    )
}